import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api, setReportsToken, getReportsToken } from "@/lib/api";
import { BarChart3 } from "lucide-react";
import { toast } from "sonner";
import BrandLogo from "@/components/BrandLogo";

export default function ReportsLogin() {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (getReportsToken()) navigate("/reports/view", { replace: true });
  }, [navigate]);

  const submit = async (e) => {
    e?.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/reports/login", { password });
      setReportsToken(r.data.token);
      toast.success("Welcome to the Reports Portal.");
      navigate("/reports/view", { replace: true });
    } catch {
      toast.error("Wrong password");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#FDFBF7]">
      <form onSubmit={submit} className="brutal-card p-8 w-full max-w-md" data-testid="reports-login-form">
        <div className="mb-6">
          <BrandLogo size="lg" title="Reports Portal" subtitle="Daily Questions · Answers · Winners" />
        </div>
        <label className="text-xs font-black uppercase mb-2 block">Password</label>
        <input
          data-testid="reports-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="brutal-input"
          autoFocus
          required
        />
        <button data-testid="reports-login-submit" type="submit" disabled={busy} className="brutal-btn w-full mt-6 flex items-center justify-center gap-2">
          <BarChart3 size={18} /> {busy ? "Logging in…" : "View Reports"}
        </button>
      </form>
    </div>
  );
}
